import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PdfPreviewDialogComponent } from '../pdf-preview-dialog/pdf-preview-dialog.component';
import { CallbackDialogComponent } from '../callback-dialog/callback-dialog.component';

interface HelpDocument {
  title: string;
  description: string;
  url: string;
  fileName: string;
  previewImage: string;
}

interface HelpContact {
  title: string;
  description: string;
  email: string;
  address: string;
  phone: string;
}

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss'],
})
export class HelpPageComponent implements OnInit {
  documents: HelpDocument[] = [];
  contact!: HelpContact;

  constructor(
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.documents = [
      {
        title: 'Short guide',
        description: 'Concise troubleshooting reference for common support tasks and quick setups.',
        url: encodeURI('/assets/json/Lenexa Troubleshooting Quick Reference Card – v1.4.pdf'),
        fileName: 'Lenexa Troubleshooting Quick Reference Card – v1.4.pdf',
        previewImage: '/assets/images/lenexa-logo.png',
      },
      {
        title: 'Detailed help',
        description: 'Comprehensive troubleshooting steps, system diagrams, and fallback guidance.',
        url: encodeURI('/assets/json/Lenexa Troubleshooting Guide – v1.2.pdf'),
        fileName: 'Lenexa Troubleshooting Guide – v1.2.pdf',
        previewImage: '/assets/images/lenexa-logo.png',
      },
    ];

    this.contact = {
      title: 'Contact us',
      description: 'Reach the Lenexa Medical team for help, training, or follow-up support.',
      email: 'support@lenexamedical.com',
      address: 'Level 1/70 Adam St, Burnley VIC 3121',
      phone: '1300 536 392',
    };
  }

  openDocument(document: HelpDocument): void {
    this.dialog.open(PdfPreviewDialogComponent, {
      width: 'min(96vw, 1100px)',
      maxWidth: '96vw',
      panelClass: 'pdf-preview-dialog-panel',
      autoFocus: false,
      data: {
        title: document.title,
        fileName: document.fileName,
        url: document.url,
        previewImage: document.previewImage,
      },
    });
  }

  openCallbackDialog(): void {
    this.dialog.open(CallbackDialogComponent, {
      width: '450px',
      autoFocus: false,
    });
  }
}
